import { Component, ChangeDetectionStrategy } from '@angular/core';
import {PermissionKeys} from '../app.constants';

@Component({
    selector: 'app-alarm',
    templateUrl: './alarm.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlarmComponent {

    PermissionKeys = PermissionKeys;

    constructor() { }

}
